import { Injectable, OnDestroy } from "@angular/core";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { ShareLink } from "../models/sharelink";
import { ShareSettings } from "../models/sharesettin";
import { ShareSettingsDialogComponent } from "../settings/sharesettings-dialog.component";
import { APIService } from "./api.component";
import { Constants } from "./constants";
import { Option } from '../models/option';
import { Utils } from "./utils.component";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { FormControl } from "@angular/forms";
import { ErrorData } from "./ErrorData";
import { SharedService } from "./shared.service";

@Injectable({
  providedIn: 'root'
})
export class ShareUtils implements OnDestroy {

  monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
  ];

  linkexpires = [0, 2, 7, 30];

  accessible: Option[];
  downloadrights: Option[];
  linkexpiresData: Option[];

  optionsAccessibleMysite: Option[] = [
    {
      alias: "ACCESS_TO_ANYONE_WHO_HAS_THE_LINK",
      default: false,
      displayname: "Anyone with the link"
    },
    {
      alias: "ACCESS_TO_USER_IN_MY_ORGANISATION_ONLY",
      default: false,
      displayname: "Users in my organisation"
    },
    {
      alias: "ACCESS_TO_SYSTEM_USERS",
      default: false,
      displayname: "Any registered system user"
    },
    {
      alias: "ACCESS_TO_ANYONE_WHO_HAS_THE_PASSWORD",
      default: false,
      displayname: "Anyone with the password"
    },
  ];

  optionsAccessibleOthersite: Option[] = [
    {
      alias: "ACCESS_TO_ANYONE_WHO_HAS_THE_LINK",
      default: true,
      displayname: "Anyone with the link"
    },
    {
      alias: "ACCESS_TO_USER_IN_MY_ORGANISATION_ONLY",
      default: false,
      displayname: "Users in my organisation"
    },
    {
      alias: "ACCESS_TO_SYSTEM_USERS",
      default: false,
      displayname: "Any registered system user"
    },
    {
      alias: "ACCESS_TO_ANYONE_WHO_HAS_THE_PASSWORD",
      default: false,
      displayname: "Anyone with the password"
    },
  ];
  optionsDrmMysite: Option[] = [
    {
      alias: "DOWNLOAD_VIEW_PRINT",
      default: false,
      displayname: "Download, view and print"
    },
    {
      alias: "VIEW_ONLY",
      default: false,
      displayname: "View only"
    },
    {
      alias: "EDIT_DOWNLOAD_VIEW_PRINT",
      default: false,
      displayname: "Edit, download, view and print"
    },
  ];

  optionsDrmOthersite: Option[] = [
    {
      alias: "DOWNLOAD_VIEW_PRINT",
      default: true,
      displayname: "Download, view and print"
    },
    {
      alias: "VIEW_ONLY",
      default: false,
      displayname: "View only"
    },
    {
      alias: "EDIT_DOWNLOAD_VIEW_PRINT",
      default: false,
      displayname: "Edit, download, view and print"
    },
  ];

  optionsSharelinkexpire: Option[] = [
    {
      alias: "0",
      default: false,
      displayname: "Never"
    },
    {
      alias: "2",
      default: false,
      displayname: "2"
    },
    {
      alias: "7",
      default: false,
      displayname: "7"
    },
    {
      alias: "30",
      default: false,
      displayname: "30"
    },
  ];
  private onDestroy$: Subject<void> = new Subject<void>();

  getShareObject(share, id, type, isMySite, password) {
    var date = new Date();
    var utils = new Utils();
    var numberOfDaysToAdd = this.linkexpires[Number(localStorage.getItem(Constants.LINKEXPIRES_STORAGE))];
    var fomatteddate;
    if (numberOfDaysToAdd != 0) {
      date.setDate(date.getDate() + Number(numberOfDaysToAdd));
      fomatteddate = utils.getEncryptedHeaderString(utils.getUtcTicks(date.getTime()).toString());//this.getFormatedDate(date);
    }
    else {
      fomatteddate = utils.getEncryptedHeaderString('NEVER');//Constants.EXPIRY_DATE_TEXT;
    }
    share.expiry = fomatteddate//set Expiry date based on link expires settings

    //Based on settings of download rights//{1(download_view_print) / 2(view_only) / 3(edit_download_view_print)}
    if (isMySite)
      share.permissions = Number(localStorage.getItem(Constants.DOWNLOADRIGHTS_MYFILES_STORAGE));
    else
      share.permissions = Number(localStorage.getItem(Constants.DOWNLOADRIGHTS_OTHERFILES_STORAGE));

    //Based on settings of Accessible by {1(anyone) / 2(my organisation user) / 3(system users)/ 4(Can be accessed by anyone who has the password) this 4th option is introduced from api version 6 onwards for sharing password protected files}.
    if (isMySite) {
      share.shareoption = Number(localStorage.getItem(Constants.ACCESSIBLEBY_MYFILES_STORAGE));
      share.ismysite = true;
    }
    else {
      share.shareoption = Number(localStorage.getItem(Constants.ACCESSIBLEBY_OTHERFILES_STORAGE));
      share.ismysite = false
    }

    if (share.permissions === 2)
      share.applywatermark = Number(localStorage.getItem(Constants.WATERMARK_OTHERFILES_STORAGE));//{0/1}Based on settings of Apply watermark
    if (share.permissions === 3)
      share.approvenewversions = Number(localStorage.getItem(Constants.APPROVE_NEW_VERSIONS_OTHERFILES_STORAGE));//{0/1}Based on settings of Approve new versions {0(approve edits is not required) / 1(approve edits by recipients before they are committed as new versions)} this option is introduced from api version 12 when permission value is 3.

    share.resourceid = Number(id);
    share.resourcetype = type; //{folder/file}. 
    share.notification = Number(localStorage.getItem(Constants.NOTIFY_EDIT_DOWNLOAD_PRINT_STORAGE));//{0/1}Based on settings of Notify me

    if (share.shareoption === 4) {
      if (password === 'undefined' || password.length < 1) {
        share.pwrd = password;
      }
      else {
        share.pwrd = utils.getEncryptedHeaderString(password);//Based on settings of accessible by if it's Anyone with password then password will come here
      }
    }
    return share;
  }

  getFormatedDate(date): string {

    return ("00" + date.getUTCDate()).slice(-2) + " "
      + this.monthNames[date.getUTCMonth()] + " "
      + date.getUTCFullYear() + " "
      + ("00" + date.getUTCHours()).slice(-2) + ":"
      + ("00" + date.getUTCMinutes()).slice(-2);
  }

  getPassword(location, share: ShareSettings) {
    if ((location.includes('My files') || location.includes('My site')) && share != null) {
      return share.pwrd;
    }
    else if (share != null) {
      return share.sitepwrd;

    }
    return "";
  }

  public getErrorMessage(passwordFc: FormControl) {
    if (passwordFc.hasError('maxlength'))
      return Constants.MAX_PASSWORD_VALIDATION;
    else if (passwordFc.hasError('strErrorMsg'))
      return Constants.ERRORMSG;
    else if (passwordFc.hasError('whitespace')) {
      return Constants.PASSWORD_VALIDATION;
    }
  }

  public generateSharedLink(apiService: APIService, share: ShareLink, dialogRef: MatDialogRef<ShareSettingsDialogComponent>, utils: Utils, dialog: MatDialog, fileFolderobj, shareutils: ShareUtils, sharedService: SharedService, errorMsg, sharebutton) {
    // 2(view_only) -if view only permission then check for folder/file type supported for viewing at collaborate 
    //If file is not supported for shared  file/folder can be downloaded even if it is shared with view only
    if (share.permissions != 2)
      this.sharelink(apiService, share, dialogRef, utils, dialog, fileFolderobj, shareutils, sharedService, errorMsg, sharebutton)
    else if (share.resourcetype == 'folder') {
      //show dialog for non viewer folder
      //errorData.errorMsg = Constants.UNSUPPORTED_VIEW_FOLDER;
      //errorData.errorCode = Constants.UNSUPPORTED_FILE_FOLDER;
      /* if (dialogRef != null)
        dialogRef.close() */
      //sharedService.isShare$.next(false)
      //sharedService.updateShareData$.next(null)
      this.sharelink(apiService, share, dialogRef, utils, dialog, fileFolderobj, shareutils, sharedService, errorMsg, sharebutton)
      /* utils.openConfirmationDialog({ errorData: errorData }, dialog, item => {
        if (item) {
          this.sharelink(apiService, share, dialogRef, utils, dialog, fileFolderobj, shareutils,sharedService,errorMsg)
        }
      }) */
    }
    else {
      if (fileFolderobj['fileType']) {
        apiService.getSupportedFileTypes(fileFolderobj['fileType'])
          .pipe(takeUntil(this.onDestroy$))
          .subscribe(supportedfile => {
            if (supportedfile['filetypes']['filetype'][0].onlineviewersupport === 1) {
              this.sharelink(apiService, share, dialogRef, utils, dialog, fileFolderobj, shareutils, sharedService, errorMsg, sharebutton)
            } else {
              //show dialog for viewer not supported files
              this.onlineViewerNotSupportedFile(dialogRef, utils, apiService, share, dialog, fileFolderobj, shareutils, sharedService, errorMsg, sharebutton)
            }

          }, err => {
            errorMsg.str = err.errorMsg
            sharebutton.isDisabled = false;
          });
      } else {
        this.onlineViewerNotSupportedFile(dialogRef, utils, apiService, share, dialog, fileFolderobj, shareutils, sharedService, errorMsg, sharebutton)
      }
    }

  }

  onlineViewerNotSupportedFile(dialogRef: MatDialogRef<ShareSettingsDialogComponent>, utils: Utils, apiService: APIService, share: ShareLink, dialog: MatDialog, fileFolderobj, shareutils: ShareUtils, sharedService: SharedService, errorMsg, sharebutton) {
    if (dialogRef != null)
      dialogRef.close()
    var errorData = new ErrorData()
    errorData.errorMsg = Constants.UNSUPPORTED_VIEW_FILE;
    errorData.errorCode = Constants.UNSUPPORTED_FILE_FOLDER;
    utils.openConfirmationDialog({ errorData: errorData }, dialog, item => {
      if (item)
        this.sharelink(apiService, share, dialogRef, utils, dialog, fileFolderobj, shareutils, sharedService, errorMsg, sharebutton)
      else {
        sharebutton.isDisabled = false;
        sharebutton.sharetitle = Constants.SHARE_LINK;
      }
    })
  }

  getIcon(FileType: string, IsFolder: boolean, utils: Utils) {
    if (IsFolder)
      return 'folder.png';
    else {
      return utils.getFileIcon(FileType) + '_icon-svg.png';
    }
  }

  sharelink(apiService: APIService, share: ShareLink, dialogRef: MatDialogRef<ShareSettingsDialogComponent>, utils: Utils, dialog: MatDialog, fileFolderobj, shareutils: ShareUtils, sharedService: SharedService, errorMsg, sharebutton) {
    apiService.shareLink(share)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(data => {
        var Icon = this.getIcon(fileFolderobj['fileType'], share.resourcetype == "folder", utils);
        this.postMstMessage(apiService, data['link'], data['resourcename'], "0", utils, Icon)
        if (dialog != null)
          dialog.closeAll();
      }, err => {
        if (err.errorMsg != Constants.SHARE_LINK_RESTRICTED_MSG) {
          errorMsg.str = err.errorMsg
          sharebutton.isDisabled = false;
        } else {
          utils.openDialog(apiService, dialog, fileFolderobj, shareutils, share, true, sharedService, errorMsg, sharebutton)
        }
      });
  }
  public postMstMessage(apiService: APIService, strLink: string, strName: string, strSize: string, utils: Utils, strIcon: string) {

    var strShareData = utils.getHtmlEncodeString(strName + Constants.DATA_SEP + strLink + Constants.DATA_SEP + strIcon + Constants.DATA_SEP + strSize);

    var strData = strShareData;
    var count = 0;
    var encryptedString;
    var encrylength = 0;

    do {
      if (strData.length > 190) {
        if (encryptedString != undefined) {
          encryptedString = encryptedString.concat(utils.getEncryptedString(strData.substring(0, 190)))
        }
        else {
          encryptedString = utils.getEncryptedString(strData.substring(0, 190))
          encrylength = encryptedString.length;
        }
        count = count + 190
        strData = strData.substring(190)
      }
      else {
        if (encryptedString != undefined) {
          encryptedString = encryptedString.concat(utils.getEncryptedString(strShareData.substring(count, strShareData.length)))
        }
        else {
          encryptedString = utils.getEncryptedString(strShareData.substring(count, strShareData.length))
          encrylength = encryptedString.length;
        }

        strData = strShareData.substring(count + 190, strShareData.length)
        count = count + strData.length
      }

    } while ((Number)(strData.length / 190) > 0)

    var shareLinkInfo = {
      cardfname: utils.getHtmlEncodeString(encryptedString),
      //  link: utils.getHtmlEncodeString(strLink),
      size: utils.getHtmlEncodeString(encrylength.toString()),
      //   icon: utils.getHtmlEncodeString(strIcon)
    }

    //Make sharelink call
    apiService.submitTask(shareLinkInfo);
    return true;
  }

  public closeMainDialog(apiService: APIService) {
    apiService.submitTask(null);
  }

  generateSharelink(fileFolderobj: object, share: ShareLink, apiService: APIService, sharesettings: ShareSettings, utils: Utils, dialog: MatDialog, shareutils: ShareUtils, sharedService: SharedService, errorMsg, sharebutton) {
    var password = this.getPassword(fileFolderobj['locations'], sharesettings)
    share = this.getShareObject(share, fileFolderobj['contentId'], fileFolderobj['types'], fileFolderobj['locations'].includes('My files') || fileFolderobj['locations'].includes('My site'), password);
    if (share != null) {
      this.generateSharedLink(apiService, share, null, utils, dialog, fileFolderobj, shareutils, sharedService, errorMsg, sharebutton)
    }
  }

  getIsLocal() {
    var date = new Date();
    if (localStorage.getItem(Constants.LINKEXPIRES_STORAGE) == "undefined") {
      return false
    } else if (localStorage.getItem(Constants.API_CALL_SHARE_SETTINGS_TIME_STORAGE) == "undefined"
      || Number(localStorage.getItem(Constants.API_CALL_SHARE_SETTINGS_TIME_STORAGE)) < date.getTime()) {
      date.setHours(date.getHours() + 12)
      localStorage.setItem(Constants.API_CALL_SHARE_SETTINGS_TIME_STORAGE, date.getTime() + "");
      return false
    }
    else
      return true;
  }

  setDataFromAPI(share: ShareSettings, isMySite) {
    if ((isMySite && share.sharevialink.options.option.length == 1) || (share.sitesharevialink == undefined || share.sitesharevialink.options.option[0].alias.length == 0)) {
      var index = this.optionsAccessibleMysite.findIndex(item => item.alias === share.sharevialink.options.option[0].alias);
      this.optionsAccessibleMysite[index].default = true;
      this.accessible = this.optionsAccessibleMysite;
    } else if (share.sitesharevialink.options.option.length == 1) {
      var otherindex = this.optionsAccessibleOthersite.findIndex(item => item.alias === share.sitesharevialink.options.option[0].alias);
      this.optionsAccessibleOthersite[otherindex].default = true;
      this.accessible = this.optionsAccessibleOthersite;
    } else if (isMySite) {
      this.accessible = share.sharevialink.options.option;
    } else {
      this.accessible = share.sitesharevialink.options.option;
    }

    if ((isMySite && share.drmsetting.options.option.length == 1) || (share.sitedrmsetting == undefined || share.sitedrmsetting.options.option[0].alias.length == 0)) {
      var indexdrm = this.optionsDrmMysite.findIndex(item => item.alias === share.drmsetting.options.option[0].alias);
      this.optionsDrmMysite[indexdrm].default = true;
      this.downloadrights = this.optionsDrmMysite;
    } else if (share.sitedrmsetting.options.option.length == 1) {
      var otherindexdrm = this.optionsDrmOthersite.findIndex(item => item.alias === share.sitedrmsetting.options.option[0].alias);
      this.optionsDrmOthersite[otherindexdrm].default = true;
      this.downloadrights = this.optionsDrmOthersite;
    } else if (isMySite) {
      this.downloadrights = share.drmsetting.options.option;
    } else {
      this.downloadrights = share.sitedrmsetting.options.option;

    }

    if (share.quicksharelinkexpiry.options.option.length == 1) {
      var indexlink = this.optionsSharelinkexpire.findIndex(item => item.alias === share.quicksharelinkexpiry.options.option[0].alias);
      this.optionsSharelinkexpire[indexlink].default = true;
      this.linkexpiresData = this.optionsSharelinkexpire;
    } else {
      this.linkexpiresData = share.quicksharelinkexpiry.options.option;
    }
  }

  public saveSettings(share: ShareSettings, isMySite) {
    this.setDataFromAPI(share, isMySite)
    var accessibleindex = this.accessible.findIndex(item => item.displayname === this.accessible.find(access => access.default).displayname);
    if (isMySite)
      localStorage.setItem(Constants.ACCESSIBLEBY_MYFILES_STORAGE, (accessibleindex + 1) + "");
    else
      localStorage.setItem(Constants.ACCESSIBLEBY_OTHERFILES_STORAGE, (accessibleindex + 1) + "");

    var downloadrightsindex = this.downloadrights.findIndex(item => item.displayname === this.downloadrights.find(downloadrights => downloadrights.default).displayname);
    if (isMySite)
      localStorage.setItem(Constants.DOWNLOADRIGHTS_MYFILES_STORAGE, (downloadrightsindex + 1) + "");
    else
      localStorage.setItem(Constants.DOWNLOADRIGHTS_OTHERFILES_STORAGE, (downloadrightsindex + 1) + "");

    var linkindex = this.linkexpiresData.findIndex(item => item.displayname === this.linkexpiresData.find(linkexpire => linkexpire.default).displayname);
    localStorage.setItem(Constants.LINKEXPIRES_STORAGE, (linkindex) + "");

    localStorage.setItem(Constants.WATERMARK_MYFILES_STORAGE, 1 + "");
    localStorage.setItem(Constants.WATERMARK_OTHERFILES_STORAGE, 1 + "");

    localStorage.setItem(Constants.APPROVE_NEW_VERSIONS_MYFILES_STORAGE, 1 + "");
    localStorage.setItem(Constants.APPROVE_NEW_VERSIONS_OTHERFILES_STORAGE, 1 + "");

    localStorage.setItem(Constants.NOTIFY_EDIT_DOWNLOAD_PRINT_STORAGE, 1 + "");

    localStorage.setItem(Constants.SHOW_DIALOG_STORAGE, share.displaysharesettings + "");
  }

  public ngOnDestroy(): void {
    this.onDestroy$.next();
  }
}
